export default "__VITE_ASSET__Mlxthrjv__"